<template>
  <div v-if="windowSummary" class="details">
    <div class="detailRow">
      <span class="detailLabel">WINDOW</span>
      <span class="detailValue mono">{{ windowSummary }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  config: Record<string, any>
}>()

const windowSummary = computed(() => {
  const w = props.config.window
  if (!w || typeof w !== 'object') return ''
  if (w.last) {
    const entries = Object.entries(w.last).filter(([, v]) => typeof v === 'number' && v > 0)
    if (entries.length === 0) return ''
    return 'Last ' + entries.map(([unit, val]) => `${val} ${unit}`).join(', ')
  }
  if (w.since) {
    return `Since ${w.since}`
  }
  if (w.between && Array.isArray(w.between) && w.between.length === 2) {
    return `${w.between[0]} to ${w.between[1]}`
  }
  return ''
})
</script>

<style scoped>
.details {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.detailRow {
  display: flex;
  align-items: baseline;
  gap: var(--space-3);
}
.detailLabel {
  font-family: var(--font-sans);
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--tracking-wide);
  color: var(--color-text-tertiary);
  flex-shrink: 0;
}
.detailValue.mono {
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: var(--fs-xs);
  color: var(--color-text-secondary);
}
</style>
